import { Injectable } from '@angular/core';
import { PermissionsService } from '@spa/api';

@Injectable()
export class BffPermissionsService extends PermissionsService {
  protected getApiUrl(): string {
    return (this as any).moduleConfig.authUrl + '/auth/api/v1/';
  }
}
